"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePropsUpdatedChildrenWithShouldUpdate = exports.usePropsUpdatedChildren = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var getChildren = function getChildren(children, elementType, updateFunc) {
  if (!children) return {
    shouldUpdate: false,
    children: children
  };
  var childrenArray;

  try {
    childrenArray = _react.Children.toArray(children);
  } catch (error) {
    return {
      shouldUpdate: false,
      children: children
    };
  }

  var struct = childrenArray.map(function (child) {
    return getChild(child, elementType, updateFunc);
  });

  if (struct.some(function (_ref) {
    var shouldUpdate = _ref.shouldUpdate;
    return shouldUpdate;
  })) {
    return {
      shouldUpdate: true,
      children: struct.map(function (_ref2) {
        var child = _ref2.child;
        return child;
      })
    };
  }

  return {
    shouldUpdate: false,
    children: children
  };
};

var getChild = function getChild(child, elementTypes, updateFunc) {
  if (!child) return {
    shouldUpdate: false,
    child: child
  };

  if (elementTypes.some(function (elementType) {
    return child.type === elementType;
  })) {
    return {
      shouldUpdate: true,
      child: /*#__PURE__*/(0, _react.cloneElement)(child, updateFunc(child.props))
    };
  }

  if (child.props) {
    var _getChildren = getChildren(child.props.children, elementTypes, updateFunc),
        shouldUpdate = _getChildren.shouldUpdate,
        children = _getChildren.children;

    if (shouldUpdate) {
      return {
        shouldUpdate: true,
        child: /*#__PURE__*/(0, _react.cloneElement)(child, _objectSpread(_objectSpread({}, child.props), {}, {
          children: children
        }))
      };
    }
  }

  return {
    shouldUpdate: false,
    child: child
  };
};

var usePropsUpdatedChildren = function usePropsUpdatedChildren(children, elementTypes, updateFunc) {
  return (0, _react.useMemo)(function () {
    var _getChildren2 = getChildren(children, elementTypes, updateFunc),
        newChildren = _getChildren2.children;

    return newChildren;
  }, [children, elementTypes, updateFunc]);
};

exports.usePropsUpdatedChildren = usePropsUpdatedChildren;

var usePropsUpdatedChildrenWithShouldUpdate = function usePropsUpdatedChildrenWithShouldUpdate(children, elementTypes, updateFunc) {
  return (0, _react.useMemo)(function () {
    var _getChildren3 = getChildren(children, elementTypes, updateFunc),
        newChildren = _getChildren3.children,
        shouldUpdate = _getChildren3.shouldUpdate;

    return {
      shouldUpdate: shouldUpdate,
      updatedChildren: newChildren
    };
  }, [children, elementTypes, updateFunc]);
};

exports.usePropsUpdatedChildrenWithShouldUpdate = usePropsUpdatedChildrenWithShouldUpdate;